export default "__VITE_ASSET__pPy0I_hu__"